// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const TechnologiesIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="TechnologiesIcon" ref={forwardedRef} {...props}>
      <path d="M8.5 8.5h3v3h-3z" />
      <path d="M10.75 3v2h1.75V3H14v2a1 1 0 0 1 1 1h2v1.5h-2v1.75h2v1.5h-2v1.75h2V14h-2a1 1 0 0 1-1 1v2h-1.5v-2h-1.75v2h-1.5v-2H7.5v2H6v-2a1 1 0 0 1-1-1H3v-1.5h2v-1.75H3v-1.5h2V7.5H3V6h2a1 1 0 0 1 1-1V3h1.5v2h1.75V3zM6.5 13.5h7v-7h-7z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const TechnologiesIcon = /* @__PURE__ */ Object.assign(
  TechnologiesIconComponent,
  { displayName: 'TechnologiesIcon' },
);
